import { useState } from 'react';
import { Activity, Crosshair } from 'lucide-react';
import { Entity360Tab } from './Entity360Tab';
import { HuntsTab } from './HuntsTab';

interface Entity360HuntOpsTabProps {
  onRunKql?: (query: string) => void;
}

export function Entity360HuntOpsTab({ onRunKql }: Entity360HuntOpsTabProps) {
  const [view, setView] = useState<'entity360' | 'hunts'>('entity360');

  return (
    <div className="space-y-4">
      <div className="inline-flex rounded-lg border border-border bg-card p-1">
        <button
          type="button"
          onClick={() => setView('entity360')}
          className={`inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-semibold transition ${
            view === 'entity360' ? 'bg-cyan-600 text-white' : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          <Activity className="h-4 w-4" /> Entity 360
        </button>
        <button
          type="button"
          onClick={() => setView('hunts')}
          className={`inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-semibold transition ${
            view === 'hunts' ? 'bg-cyan-600 text-white' : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          <Crosshair className="h-4 w-4" /> HuntOps
        </button>
      </div>
      {view === 'entity360' ? <Entity360Tab onRunKql={onRunKql} /> : <HuntsTab />}
    </div>
  );
}
